import LineSegment from './classes/line_segment';

function getOuterLines(lineSegment, offset, isFirst = false, isLast = false, endingOffset = true) {
	const cx = (lineSegment.x1 + lineSegment.x2) / 2;
	const cy = (lineSegment.y1 + lineSegment.y2) / 2;

	const perp = lineSegment.getPerpendicularLine({ x: cx, y: cy });

	const angle = Math.atan2(lineSegment.y2 - lineSegment.y1, lineSegment.x2 - lineSegment.x1);
	const a1 = angle + Math.PI / 2;
	const a2 = angle - Math.PI / 2;

	const tp1 = { x: cx + Math.cos(a1) * (offset / 2), y: cy + Math.sin(a1) * (offset / 2) };
	const tp2 = { x: cx + Math.cos(a2) * (offset / 2), y: cy + Math.sin(a2) * (offset / 2) };

	const lines = [perp.getPerpendicularLine(tp1), perp.getPerpendicularLine(tp2)];

	let a3 = null;
	let tp3 = null;

	if (isFirst) {
		a3 = angle + Math.PI;

		if (endingOffset) {
			tp3 = { x: lineSegment.x1 + Math.cos(a3) * (offset / 2), y: lineSegment.y1 + Math.sin(a3) * (offset / 2) };
		} else {
			tp3 = { x: lineSegment.x1, y: lineSegment.y1 };
		}
	} else if (isLast) {
		a3 = angle;

		if (endingOffset) {
			tp3 = { x: lineSegment.x2 + Math.cos(a3) * (offset / 2), y: lineSegment.y2 + Math.sin(a3) * (offset / 2) };
		} else {
			tp3 = { x: lineSegment.x2, y: lineSegment.y2 };
		}
	}

	if (tp3) {
		lines.push(lineSegment.getPerpendicularLine(tp3));
	}

	return lines;
}

export function simplifyPath(path) {
	const out = [path[0]];

	for (let i = 1; i < path.length - 1; i++) {
		const p1 = out.at(-1);
		const [p2, p3] = path.slice(i, i + 2);

		const l1 = LineSegment.fromPoints(p1, p2);
		const l2 = LineSegment.fromPoints(p2, p3);

		if (l1.line.slope !== l2.line.slope) {
			out.push(p2);
		}
	}

	out.push(path.at(-1));

	return out;
}

export function makeOutline(line, lineWidth, endingOffset = true) {
	const points = [];

	for (let i = 0; i < line.length - 2; i++) {
		const [p1, p2, p3] = line.slice(i, i + 3);

		const ls1 = LineSegment.fromPoints(p1, p2);
		const ls2 = LineSegment.fromPoints(p2, p3);

		const [pl1, pl2, pls] = getOuterLines(ls1, lineWidth, i === 0, false, endingOffset);
		const [pl3, pl4, ple] = getOuterLines(ls2, lineWidth, false, i + 2 === line.length - 1, endingOffset);

		if (pls) {
			const ip1 = pls.intersectsWith(pl1);
			const ip2 = pls.intersectsWith(pl2);

			points.push(ip1, ip2);
		}

		const ip3 = pl1.intersectsWith(pl3);
		const ip4 = pl2.intersectsWith(pl4);

		points.push(ip3, ip4);

		if (ple) {
			const ip5 = ple.intersectsWith(pl3);
			const ip6 = ple.intersectsWith(pl4);

			points.push(ip5, ip6);
		}
	}

	const out = [];

	for (let i = 0; i < points.length; i += 2) {
		out.push(points[i]);
	}
	for (let i = points.length - 1; i >= 0; i -= 2) {
		out.push(points[i]);
	}

	return out;
}

export function convertToSVG(shape, width, height) {
	return `<svg viewBox="0 0 ${width} ${height}"><path d="M${shape[0].x},${shape[0].y}${shape
		.slice(1)
		.map((point) => `L${point.x},${point.y}`)
		.join('')}Z"/></svg>`;
}
